export const EntitySelectorEntity = Object.freeze({
	Epic: 'epic-selector',
	Flow: 'flow',
	Project: 'project',
	Group: 'group',
	Tag: 'task-tag',
	TemplateTag: 'template-tag',
	User: 'user',
	Department: 'department',
	StructureNode: 'structure-node',
	Deal: 'deal',
	Contact: 'contact',
	Company: 'company',
	Lead: 'lead',
	SmartInvoice: 'smart_invoice',
	DynamicMultiple: 'dynamic_multiple',
	ReminderRecipient: 'reminder-recipient',
	Task: 'task-with-id',
	TemplateCommon: 'task-template',
	Template: 'task-template-with-id',
	MetaUser: 'meta-user',
	AllUser: 'all-users',
});
